import { render, staticRenderFns } from "./DownLoadApp.vue?vue&type=template&id=85fe789e&scoped=true"
import script from "./DownLoadApp.vue?vue&type=script&lang=js"
export * from "./DownLoadApp.vue?vue&type=script&lang=js"
import style0 from "./DownLoadApp.vue?vue&type=style&index=0&id=85fe789e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85fe789e",
  null
  
)

export default component.exports